const mvSwiper = new Swiper('.mv-swiper', {
  // Optional parameters
  autoplay: {
    delay: 4000,
  },
  loop: true,
  //effect: 'fade',
  slidesPerView: 1.5,
  spaceBetween: 20,
  centerInsufficySlides: true,
  centeredSlides: true,
  centeredSlidesBounds: true,
  initialSlide: 0,
});

const MvSwiper = new Swiper('.new-mv-swiper', {
  // Optional parameters
  autoplay: {
    delay: 4000,
  },
  pagination: {
    el: '.swiper-pagination', 
    clickable: true,
  },
  loop: true,
  slidesPerView: 1,
  breakpoints: {
    641: {
      slidesPerView: 1.5,
      spaceBetween: 20,
      centerInsufficySlides: true,
      centeredSlides: true,
      centeredSlidesBounds: true,
      initialSlide: 0,
    }
  }  
});